 <template>
  <div class="acuerdo-detail">
    <md-sidenav @close="close()" class="md-right" ref="rightSidenav">
        <md-toolbar>
            <div class="md-toolbar-container"> 
                <h4 class="md-title">Acuerdo de Objetivos</h4>
                <md-button @click.native="closeRightSidenav()" class="md-icon-button close">
                    <md-icon>close</md-icon>
                </md-button>
            </div>
        </md-toolbar>
        <md-subheader>
            <div v-if="acuerdo">Dueño {{acuerdo.ownerObject.displayName}}</div>
        </md-subheader>
        <md-subheader>
            <div v-if="acuerdo">Editor {{acuerdo.editorObject.displayName}}</div>            
        </md-subheader>

        <md-layout md-gutter>
            <md-card md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-align="center" class="card-obj-detail" v-for="(obj, index) in objetivos" :key="index">
                <md-card-header>
                    <div class="md-title">Objetivo {{index + 1}}</div>
                </md-card-header>
                <md-card-content>
                    <div>
                        {{obj.descripcion}}
                    </div>
                    <div>
                        {{obj.notas}}
                    </div>
                    <md-checkbox @change="change(obj)" :disabled="acuerdo && (currentUser.email !== acuerdo.editorObject.email || acuerdo.finalizado !== undefined)" v-model="obj.cumplido">Cumplido?</md-checkbox>
                    <md-input-container v-if="obj.cumplido">
                      <label>Fecha</label>
                      <md-input v-model="obj.fecha" :disabled="currentUser.email !== acuerdo.editorObject.email || acuerdo.finalizado !== undefined" type="date"></md-input>
                    </md-input-container>
                </md-card-content>
            </md-card>
        </md-layout>
        <div class="container-buttons" v-if="acuerdo.editorObject && acuerdo.editorObject.email === currentUser.email && !acuerdo.finalizado">
            <md-button class="md-raised md-primary" @click.native="guardar()">Guardar</md-button>
            <md-button class="md-raised md-primary" @click.native="finalizar()">Finalizar</md-button>
        </div>
    </md-sidenav>
  </div>
</template>

<script>
import ObjetivosService from '../services/objetivos'
import FluxerService from '../services/fluxer'
import NotificationsService from '../services/notifications'
import Router from '../router'

export default {
  name: 'acuerdo-detail',
  data () {
    return {
      fluxerSelected: this.$route.params.fluxerSelected,
      currentUser: FluxerService.getCurrentUser(),
      acuerdo: false
    }
  },
  mounted: function () {
    ObjetivosService.getById(this.$route.params.id).then((response) => {
      this.acuerdo = response.data
      this.$refs.rightSidenav.toggle()
    })
  },
  firebase: function () {
    return {
      objetivos: ObjetivosService.getObjetivosByAcuerdo(this.$route.params.id)
    }
  },
  methods: {
    close () {
      if (this.$route.name === 'acuerdo-detail') {
        Router.replace({name: 'acuerdo-objetivos'})
      } else if (this.$route.name === 'acuerdo-detail-reporte') {
        Router.replace({name: 'reporte-objetivos'})
      } else {
        Router.replace({name: 'mis-objetivos'})
      }
    },
    toggle () {
      this.$refs.rightSidenav.toggle()
    },
    closeRightSidenav () {
      this.$refs.rightSidenav.close()
    },
    change (obj) {
      if (obj.cumplido) {
        obj.fecha = null
      }
    },
    guardar () {
      ObjetivosService.guardar(this.$route.params.id, this.objetivos).then((data) => {
        this.closeRightSidenav()
      })
    },
    finalizar () {
      ObjetivosService.finalizar(this.$route.params.id, this.objetivos).then((data) => {
        NotificationsService.finalizarObjetivos(this.$route.params.id, this.currentUser, this.acuerdo.owner)
        this.closeRightSidenav()
      })
    }
  }
}
</script>

<style>
    .close {
        right: 0;
        position: absolute !important;
    }

    .form-question {
        padding: 0 16px;
    }

    .card-obj-detail {
        margin: 10px;
        width: 280px;
        min-height: 244px !important;
    }

    .delete-obj {
        position: absolute;
        top: 0px;
        right: 5px;
    }

    .container-buttons {
        padding: 20px 0;
    }
</style>



// WEBPACK FOOTER //
// AcuerdoDetail.vue?30160f8e